import React, { useState, useEffect } from "react";
import { CategoryDropDown, Caption, PrimaryButton, Title } from "../../router";
import { commonClassNameOfInput } from "../../components/common/Design";
import axios from 'axios'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'


export const Count = () => {
  const [open, setOpen] = useState(false)
  const [edit, setEdit] = useState(false)
  const [content, setContent] = useState('')
  const [id, setID] = useState(0)
  const [alert, setAlert] = useState([])


  const onChange = async (e) => {
    setContent(e.target.value)
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (content == '') {
      toast.error("Cannot send the alert count because it is empty", { theme: 'colored' })
    }
    else {
      const requestBody = {
        count: content

      }
      const hed = {
        headers: {
          authorization: `Bearer ${localStorage.getItem('token')}`

        }
      }
      let responseData = await axios.post(`${process.env.REACT_APP_API_URL}add-alert-count`, requestBody, hed).then(response => {
        toast.success("Count sent successfully", { theme: 'colored' })
        setContent('')
        getAllAlert()
        setOpen(false)

      }).catch(error => {
        console.log(error)
        if (error.response.status === 400 || error.response.status === 403) {
          toast.error(error.response.data.status, { theme: 'colored' })
        } else {
          toast.error("sorry... the backend server is down!! please try again later", { theme: 'colored' })
        }
      })
    }


  }

  const handleSubmitEdit = async (e) => {
    e.preventDefault();
    if (content == '') {
      toast.error("Cannot send the alert count because it is empty", { theme: 'colored' })
    }
    else {
      const requestBody = {
        count: content,
        id: id

      }
      const hed = {
        headers: {
          authorization: `Bearer ${localStorage.getItem('token')}`

        }
      }
      let responseData = await axios.post(`${process.env.REACT_APP_API_URL}add-alert-count`, requestBody, hed).then(response => {
        toast.success("Count edit successfully", { theme: 'colored' })
        setContent('')
        getAllAlert()
        setOpen(false)

      }).catch(error => {
        console.log(error)
        if (error.response.status === 400 || error.response.status === 403) {
          toast.error(error.response.data.status, { theme: 'colored' })
        } else {
          toast.error("sorry... the backend server is down!! please try again later", { theme: 'colored' })
        }
      })
    }


  }
  function handleEdit(obj) {
    setOpen(true)
    setContent(obj.count)
    setID(obj.id)
    setEdit(true)
  }
  function  handleDelete(obj) {
      
      const hed = {
        headers: {
          authorization: `Bearer ${localStorage.getItem('token')}`

        }
      }
      let responseData =  axios.delete(`${process.env.REACT_APP_API_URL}delete/count/${obj.id}`, hed).then(response => {
        toast.success("Count delete successfully", { theme: 'colored' })
        getAllAlert()
    
      }).catch(error => {
        console.log(error)
        if (error.response.status === 400 || error.response.status === 403) {
          toast.error(error.response.data.status, { theme: 'colored' })
        } else {
          toast.error("sorry... the backend server is down!! please try again later", { theme: 'colored' })
        }
      })
    
  }
  function addCountOpenModal() {
    setOpen(true)
    setContent('')
    setEdit(false)
  }
  const getAllAlert = async (e) => {

    const hed = {
      headers: {
        authorization: `Bearer ${localStorage.getItem('token')}`

      }
    }
    axios.get(`${process.env.REACT_APP_API_URL}all-count`, hed).then((response) => {
      console.log(response.data.find_count)
      setAlert((response.data.find_count))
    });
  }
  useEffect(() => {
    getAllAlert();

  }, [])
  return (
    <>
      <section className="p-8 bg-white shadow-s1 rounded-xl">
        <button
          type="button"
          onClick={addCountOpenModal}
          className="inline-flex justify-center w-full px-3 py-2 text-sm font-semibold text-white bg-red-600 rounded-md shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
        >
          Add Alert Content
        </button>

        <hr className="my-5" />

        <table className="w-full text-sm text-left text-gray-500 rtl:text-right">
          <thead className="text-xs text-gray-700 uppercase bg-gray-100">
            <tr>
              <th scope="col" className="px-6 py-5">
                #
              </th>
              <th scope="col" className="px-6 py-5">
                Content
              </th>
              <th scope="col" className="px-6 py-5">
                Time
              </th>
              <th scope="col" className="px-6 py-5">
                Date
              </th>
              <th scope="col" className="px-6 py-5">
                Action
              </th>

            </tr>
          </thead>
          <tbody>


            {alert.map((item, index) => {
              return (
                <tr className="bg-white border-b hover:bg-gray-50" key={index}>
                  <td className="px-6 py-4">{index + 1}</td>
                  <td className="px-8 py-6 capitalize">{item.count}</td>
                  <td className="px-1 py-6 text-blue-500">{item.created_time}</td>
                  <td className="px-6 py-6 text-red-500 w-[200px]">{item.created_at}</td>
                  <td className="px-1 py-6 text-blue-500">
                    <button
                      style={{ backgroundColor: '#B8860B', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '5px' }}
                      onClick={() => handleEdit(alert[index])}
                    >
                      Edit
                    </button>
                    <spam> </spam>
                    <button
                      style={{ backgroundColor: 'darkgreen', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '5px' }}
                      onClick={() => handleDelete(alert[index])}
                    >
                      Delete
                    </button>
                  </td>

                </tr>
              );
            })}
          </tbody>
        </table>

        <Dialog open={open} onClose={setOpen} className="relative z-10">
          <DialogBackdrop
            transition
            className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
          />

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0">
              <DialogPanel
                transition
                className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
              >
                <div className="px-4 pt-5 pb-4 bg-white sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="flex items-center justify-center mx-auto bg-red-100 rounded-full size-12 shrink-0 sm:mx-0 sm:size-10">
                      <ExclamationTriangleIcon aria-hidden="true" className="text-red-600 size-6" />
                    </div>
                    <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                      <DialogTitle as="h3" className="text-base font-semibold text-gray-900">
                        Add Message Count
                      </DialogTitle>
                      <div className="mt-2">
                        <p className="text-sm text-gray-500">
                          This is an ad to add a message count for Hutch service purposes.
                        </p>
                        <form className="text-sm text-gray-500">
                          <div>
                            {/* <Caption className="mb-2">Count </Caption> */}
                            <textarea name="description" className={`${commonClassNameOfInput}`} cols="30" rows="5" required
                              value={content} onChange={onChange}
                            ></textarea>
                          </div>

                          {/* <button type="submit" className="w-full px-16 py-3 my-5 text-lg font-medium text-white transition ease-in-out rounded-none rounded-full bg-green hover:bg-primary"  onClick={handleSubmit}>
                            ADD COUNT
                          </button> */}
                          {!edit && <button type="submit" className="w-full px-16 py-3 my-5 text-lg font-medium text-white transition ease-in-out rounded-none rounded-full bg-green hover:bg-primary" onClick={handleSubmit}>
                            ADD COUNT
                          </button>}
                          {edit && <button type="submit" className="w-full px-16 py-3 my-5 text-lg font-medium text-white transition ease-in-out rounded-none rounded-full bg-green hover:bg-primary" onClick={handleSubmitEdit}>
                            EDIT COUNT
                          </button>}
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="px-4 py-3 bg-gray-50 sm:flex sm:flex-row-reverse sm:px-6">
                  <button
                    type="button"
                    data-autofocus
                    onClick={() => setOpen(false)}
                    className="inline-flex justify-center w-full px-3 py-2 mt-3 text-sm font-semibold text-gray-900 bg-white rounded-md shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                  >
                    Close
                  </button>
                </div>
              </DialogPanel>
            </div>
          </div>
        </Dialog>
      </section>
      <ToastContainer />
    </>
  );
};
